"use strict";
/*
 * Created on 03 10 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * <p>
 *     DTO represents mapping of product to a set of suppliers. It was originally intended to store all product suppliers, but it
 *     can be used within different use cases.
 * </p>
 *
 * @author ADr
 */


var ProductSuppliersGroup =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ProductSuppliersGroup, _DomainObject_1$Domai);

  /**
   * @param productId internal id of internal product
   * @param supplierIds all potential product suppliers
   */
  function ProductSuppliersGroup(productId, supplierIds) {
    var _this;

    _classCallCheck(this, ProductSuppliersGroup);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ProductSuppliersGroup).call(this));
    _this.productId = productId;
    _this.supplierIds = supplierIds;
    return _this;
  }

  return ProductSuppliersGroup;
}(DomainObject_1.DomainObject);

exports.ProductSuppliersGroup = ProductSuppliersGroup;

ProductSuppliersGroup.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(ProductSuppliersGroup.name);
  return {
    productId: builder.str('supplierId'),
    supplierIds: builder.setOf(builder.str('supplierIds'))
  };
}();